import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { MoreHoriz, AddCircle, RemoveCircle, DragIndicator } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect } from 'react';
import { CITY_GUIDE_EDIT } from '../../../../../constants/CityGuideConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_CITY_GUIDE,
} from '../../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { PARTIAL_CHECKBOX_GREEN, updateSelectedModule } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const CityGuideTable = (props) => {
  const {
    list,
    setCityGuideList,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onClickRowViewDetails,
    onViewDetails,
    onClickDelete,
    handleChangePage,
    handleChangeRowsPerPage,
    onOpenDrawer,
    permissions,
    onActiveDeActiveCityGuide,
    setVisible,
    searchText,
    handleSelectAll,
    isAllSelected,
    setIsAllSelected,
    handleCheckboxChange,
    setActionMenuList,
    selectedGuidesLength,
    dragDisabled,
  } = props;

  useEffect(() => {
    updateSelectedModule(list, setActionMenuList, setIsAllSelected);
  }, [list]);

  const lengthOfInitialGuideList = list?.length;

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedGuidesLength}
                totalLength={lengthOfInitialGuideList}
                inputProps={{
                  'aria-label': 'select all City Guide',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-35'>Name</TableCell>
            <TableCell className='w-25'>Category</TableCell>
            <TableCell className='w-20 distance-from-hotel'>Distance from Hotel</TableCell>
            <TableCell className='w-20 distance-from-hotel text-center'>Status</TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(event, setVisible, list, setCityGuideList, false, page, rowsPerPage)
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='cms' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : list
                ).map((cityGuide, key) => (
                  <Draggable
                    key={cityGuide.id}
                    draggableId={cityGuide.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(cityGuide, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 1.5 }}>
                              <DragIndicator className='res-menu-accordion-drag ' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(cityGuide?.id)}
                            checked={cityGuide?.isChecked || false}
                            inputProps={{
                              'aria-label': `select notification ${cityGuide.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-35'>{cityGuide?.name}</TableCell>
                        <TableCell className='w-25'>
                          {cityGuide?.categoryName ? cityGuide?.categoryName : '---'}
                        </TableCell>
                        <TableCell className='w-20 distance-from-hotel'>
                          {cityGuide?.distanceFromHotel}{' '}
                          {!cityGuide?.units
                            ? '---'
                            : cityGuide?.units === 'Kilometers'
                            ? 'KMS'
                            : cityGuide?.units}
                        </TableCell>
                        <TableCell className='w-20 distance-from-hotel'>
                          <div className='d-flex justify-content-center'>
                            <div
                              className={`pill d-flex justify-content-center align-items-center ${
                                cityGuide?.isActive
                                  ? 'pill-active'
                                  : 'pill-inactive theme-dark-green'
                              }`}
                            >
                              <span className='ms-1'>
                                {cityGuide?.isActive ? 'Active' : 'Inactive'}
                              </span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align='right'>
                          {permissions[RBAC_TYPE_CMS_CITY_GUIDE] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, cityGuide);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          <Menu
                            id={key}
                            anchorEl={selectedValue?.anchorEl}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            keepMounted
                            open={
                              Boolean(selectedValue.anchorEl) && selectedValue.id === cityGuide.id
                            }
                            onClose={handleClose}
                            className='shadow'
                          >
                            <MenuItem
                              className='pe-4'
                              onClick={(e) =>
                                onActiveDeActiveCityGuide(
                                  e,
                                  selectedValue?.cityGuide?.isActive ? 'deactivate' : 'activate',
                                )
                              }
                            >
                              {selectedValue?.cityGuide?.isActive ? (
                                <>
                                  <RemoveCircle className='me-2 action-menu-icon' />
                                  Deactivate
                                </>
                              ) : (
                                <>
                                  <AddCircle className='me-2 action-menu-icon' />
                                  Activate
                                </>
                              )}
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onOpenDrawer(e, CITY_GUIDE_EDIT)}
                            >
                              <CreateIcon className='me-2 action-menu-icon' />
                              Edit
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onViewDetails(cityGuide, e)}>
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onClickDelete(e)}>
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={list.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default CityGuideTable;
